import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative flex-1 overflow-hidden bg-catering-cream-100" }
const _hoisted_2 = {
  class: "sr-only",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_3 = { class: "relative space-y-3 px-3 py-4" }
const _hoisted_4 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_5 = { class: "flex flex-wrap gap-2 px-1" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "text-center"
}
const _hoisted_8 = ["data-bot-msg-id"]

import { computed, onMounted, nextTick, ref, watch } from 'vue'
import BotMessage from '@/components/catering/bottleBot/BotMessage.vue'
import BotTyping from '@/components/catering/bottleBot/BotTyping.vue'
import { latestAssistantMessage } from '@/helpers/botMessageList'
import { scrollToBottom, anchorMessageToTop, nextScrollAction } from '@/helpers/botScroll'
import { CATERING_BOT_PATTERN_DATAURI, CATERING_BOT_PATTERN_OPACITY } from '@/asset/img/cateringBotPattern'
import { ECOMMERCE_BOT_PATTERN_DATAURI, ECOMMERCE_BOT_PATTERN_OPACITY } from '@/asset/img/ecommerceBotPattern'
import { suggestedPromptsForPlatform, showChatWelcome } from '@/helpers/botSuggestedPrompts'
import { botWidgetCopy } from '@/config/botWidgetCopy'

const ANCHOR_TOP_OFFSET = 16

export default {
  __name: 'BotMessageList',
  props: {
  messages: { type: Array, default: () => [] },
  typing: { type: Boolean, default: false },
  hasMoreCursor: { type: Boolean, default: false },
  platform: { type: String, default: 'catering' }
},
  emits: ['load-more', 'suggest'],
  setup(__props) {

const props = __props

const pattern = computed(() =>
  props.platform === 'ecommerce' ? ECOMMERCE_BOT_PATTERN_DATAURI : CATERING_BOT_PATTERN_DATAURI
)
const patternOpacity = computed(() =>
  props.platform === 'ecommerce' ? ECOMMERCE_BOT_PATTERN_OPACITY : CATERING_BOT_PATTERN_OPACITY
)
const suggestedPrompts = computed(() => suggestedPromptsForPlatform(props.platform))
const welcomeMessage = computed(() => ({
  id: '__welcome__',
  role: 'assistant',
  content: botWidgetCopy(props.platform).greeting,
  render_blocks: []
}))
const showWelcome = computed(() => showChatWelcome(props.messages, props.typing))
const latestAssistant = computed(() => latestAssistantMessage(props.messages))
const scrollEl = ref(null)
let scrollState = { count: props.messages.length, lastId: props.messages[props.messages.length - 1]?.id ?? null }

onMounted(async () => {
  await nextTick()
  scrollToBottom(scrollEl.value)
})
watch(
  () => props.messages,
  async messages => {
    const { action, anchorUserId, next } = nextScrollAction(scrollState, messages)
    scrollState = next
    if (action === 'none') return
    await nextTick()
    if (action === 'anchor') {
      const target = Array.from(scrollEl.value?.querySelectorAll('[data-bot-msg-id]') || []).find(
        el => el.dataset.botMsgId === String(anchorUserId)
      )
      if (target) return anchorMessageToTop(scrollEl.value, target, ANCHOR_TOP_OFFSET)
    }
    scrollToBottom(scrollEl.value)
  },
  { deep: false }
)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "pointer-events-none absolute inset-0",
      style: _normalizeStyle({ backgroundImage: `url('${pattern.value}')`, backgroundRepeat: 'repeat', opacity: patternOpacity.value }),
      "aria-hidden": "true"
    }, null, 4),
    _createElementVNode("div", {
      ref_key: "scrollEl",
      ref: scrollEl,
      class: "absolute inset-0 overflow-y-auto overscroll-contain",
      style: {"overscroll-behavior":"contain"}
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(latestAssistant.value), 1),
      _createElementVNode("div", _hoisted_3, [
        (showWelcome.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(BotMessage, { message: welcomeMessage.value }, null, 8, ["message"]),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestedPrompts.value, (prompt) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: prompt,
                    type: "button",
                    class: "rounded-full border border-catering-cream-300 bg-catering-cream-50 px-3 py-1.5 text-sm text-catering-ink-700 shadow-catering-xs hover:bg-catering-cream-200",
                    onClick: $event => (_ctx.$emit('suggest', prompt))
                  }, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", {
                      class: "mr-0.5 font-semibold text-catering-honey-500",
                      "aria-hidden": "true"
                    }, "+", -1)),
                    _createTextVNode(" " + _toDisplayString(prompt), 1)
                  ], 8, _hoisted_6))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (__props.hasMoreCursor)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "rounded-full border border-catering-cream-300 bg-catering-cream-50 px-3 py-1 text-xs text-catering-ink-500 hover:bg-catering-cream-200",
                      onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('load-more')))
                    }, " Load older messages ")
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.messages, (m) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: m.id,
                  "data-bot-msg-id": m.id
                }, [
                  _createVNode(BotMessage, { message: m }, null, 8, ["message"])
                ], 8, _hoisted_8))
              }), 128)),
              (__props.typing)
                ? (_openBlock(), _createBlock(BotTyping, { key: 1 }))
                : _createCommentVNode("", true)
            ], 64))
      ])
    ], 512)
  ]))
}
}

}